import WaveSurfer from "wavesurfer.js";

export async function decodeAudioPeaksFromUrl(
  url: string,
): Promise<{ peaks: number[][]; durationMs: number }> {
  const container = document.createElement("div");
  container.style.position = "absolute";
  container.style.left = "-9999px";
  container.style.width = "1px";
  container.style.height = "1px";
  document.body.appendChild(container);

  const wavesurfer = WaveSurfer.create({ container, url, height: 1 });

  try {
    await new Promise<void>((resolve, reject) => {
      wavesurfer.on("ready", () => resolve());
      wavesurfer.on("error", (error) => reject(error));
    });

    const peaks = wavesurfer.exportPeaks({
      channels: 2,
      maxLength: 8000,
      precision: 10000,
    });
    const duration = wavesurfer.getDuration();
    const durationMs = Number.isFinite(duration)
      ? Math.round(duration * 1000)
      : 0;

    return { peaks, durationMs };
  } finally {
    wavesurfer.destroy();
    container.remove();
  }
}
